<template>
  <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="500px" :destroy-on-close="true" :before-close="cancel">
    <div class="detail-grid single-column">
      <div class="detail-item">
        <span class="detail-label">物料名称</span>
        <span class="detail-value">{{ materialName }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">物料类型</span>
        <span class="detail-value">
          <el-tag v-if="materialType === 'PROTECT_REAGENT'" type="success" size="small">保护剂</el-tag>
          <el-tag v-else-if="materialType === 'SINGLE_PAGER'" type="warning" size="small">宣传品</el-tag>
          <el-tag v-else-if="materialType === 'NAME_CARD'" type="danger" size="small">名片</el-tag>
          <el-tag v-else-if="materialType === 'DRY_ICE'" type="danger" color="#ffffff" size="small">干冰</el-tag>
          <el-tag v-else-if="materialType === 'OTHER'" type="warning" color="#ffffff" size="small">其他</el-tag>
          <el-tag v-else-if="materialType === 'GIFT'" size="small">礼品</el-tag>
          <el-tag v-else type="info" size="small">未知类型</el-tag>
        </span>
      </div>
      <div class="detail-item">
        <span class="detail-label">物料位置</span>
        <span class="detail-value">{{ materialPlace }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">创建人</span>
        <span class="detail-value">{{ createBy }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">创建时间</span>
        <span class="detail-value">{{ createTime }}</span>
      </div>
      <div class="detail-item full-width">
        <span class="detail-label">备注</span>
        <span class="detail-value">{{ remark }}</span>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="primary" class="title" @click="cancel">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>

export default {
  name: "LexiconDetails",
  props:['showDialog','selectDetail'],
  data(){
    return{
      title:'查看词库词条信息详情',
      id:'',
      remark:'',
      createBy:'',
      createTime:'',
      materialName:'',
      materialType:'',
      materialPlace:'',
    }
  },
  watch:{
    'selectDetail':{
      handler(newVal){
        if(newVal&&Object.keys(newVal)){
          this.id = newVal.id
          this.createBy = newVal.createBy
          this.createTime = newVal.createTime
          this.materialName = newVal.materialName
          this.materialType = newVal.materialType
          this.materialPlace = newVal.materialPlace
          this.remark = newVal.remark
        }
      },
      immediate:true
    },
  },
  methods:{
    cancel(){
      this.$emit('submit','cancel')
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/detail.css";
</style>
